import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import PerformanceMonitor, { preloadCriticalResources } from './utils/performance'
import { createSkipLink } from './utils/accessibility'

// Initialize performance monitoring
const monitor = PerformanceMonitor.getInstance();
monitor.init();

// Preload critical resources for better performance
preloadCriticalResources();

// Add accessibility skip link
createSkipLink();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
